module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap weex-ct weex-div",
    style: (_vm._px2rem(_vm.wrapStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.isShowIndicator) ? _c('div', {
    staticClass: "select-area weex-ct weex-div",
    style: (_vm._px2rem(_vm.indicatorStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.label) ? _c('p', {
    staticClass: "item-label weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.labelStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('scroller', {
    ref: "scroller",
    staticClass: "scroller",
    style: (_vm._px2rem(_vm.scrollerStyle, 75)),
    attrs: {
      "append": "tree",
      "offset-accuracy": "10",
      "show-scrollbar": false,
      "data-evt-touchstart": "",
      "data-evt-touchend": "",
      "data-evt-scroll": ""
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.handleStart($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.handleEnd($event)
      },
      "weex$scroll": function($event) {
        $event.stopPropagation();
        return _vm.scroll($event)
      }
    }
  }, _vm._l((_vm.calcListArray), function(item, index) {
    return _c('div', {
      key: index,
      ref: "item",
      refInFor: true,
      staticClass: " weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [_c('p', {
      staticClass: "list-item weex-el weex-text",
      class: item['classes'],
      style: (_vm._processExclusiveStyle(_vm.itemStyle, 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c689dc9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c689dc9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-scroll-picker/index.vue
// module id = 581
// module chunks = 0 1